import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

const QualityConsumableView = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(454)); 
    console.log(permission);

    axios
      .get(`/quality-consumables/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        console.log(response);

        if (response.data.code === 200) {
          setValue(response.data.data.product);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  // console.log(value);

  // const viewFile =(link) =>{
  //   AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
  //   AWS.config.update({
  //   accessKeyId: AWS_ACCESS_KEY_ID,
  //   secretAccessKey: AWS_SECRET_ACCESS_KEY,
  //   region: AWS_DEFAULT_REGION,
  //   signatureVersion: 'v4',
  //   });
  //   const s3 = new AWS.S3();
  //   var params = {Bucket: AWS_BUCKET, Key: link};
  //   return  s3.getSignedUrl('getObject', params);
  // }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">View Quality Consumable</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-consumables">
                      Quality Consumables
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Quality Consumable
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.list == 1 && (
                  <div className="card-body">
                  <h4 className="card-title">Consumble Details</h4>
                  <table className="table table-bordered">
                    <tr>
                      <th className="p-3">Consumble Name</th>
                      <td className="p-3">
                        {value.consumable_name}
                      </td>
                    </tr>
                    <tr>
                      <th className="p-3">Critical level</th>
                      <td className="p-3">
                        {value.critical_level}
                      </td>
                    </tr>
                    <tr>
                      <th className="p-3">Average level</th>
                      <td className="p-3">
                        {value.average_level}
                      </td>
                    </tr>
                   <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.section_type ? value.section_type.title : ""}
                        </td>
                      </tr>
                 
                    <tr>
                      <th className="p-3">Description</th>
                      <td className="p-3">
                        {value.description}
                      </td>
                    </tr>
                 
                
                 
                  
                   
                  </table>
                
                </div>
              )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityConsumableView;
